import { z } from 'zod';

const MediaTypesQuery = z.array(z.object({
    Id: z.number(),
    Name: z.string(),
}));

export { MediaTypesQuery };